/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from "@sentry/react";

type LogAttributes = Record<string, any>;

export const sentryLog = {
  trace: (msg: string, attrs?: LogAttributes) =>
    Sentry.logger.trace(msg, attrs),
  debug: (msg: string, attrs?: LogAttributes) =>
    Sentry.logger.debug(msg, attrs),
  info: (msg: string, attrs?: LogAttributes) => Sentry.logger.info(msg, attrs),
  warn: (msg: string, attrs?: LogAttributes) => Sentry.logger.warn(msg, attrs),
  error: (msg: string, attrs?: LogAttributes) =>
    Sentry.logger.error(msg, attrs),
  fatal: (msg: string, attrs?: LogAttributes) =>
    Sentry.logger.fatal(msg, attrs),
};
